// src/contexts/AuthContext.js

import React, { createContext, useContext, useState, useEffect } from 'react';
import apiClient from '../api/apiClient'; 

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(localStorage.getItem('admin_token'));
    
    // 修改這裡：移除了 setIsAppReady，因為你沒有用到它
    const [isAppReady] = useState(true); 

    useEffect(() => {
        if (token) {
            localStorage.setItem('admin_token', token);
        } else {
            localStorage.removeItem('admin_token');
        }
    }, [token]);

    // [已刪除] 移除了 useEffect 中的 setupApp 和 loadOrInitializeTokens 調用
    // 因為現在不需要預先獲取 visitorId 或簽名 token

    const login = async (username, password) => {
        try {
            const response = await apiClient.post('/admin/login', { username, password });
            if (response.data.token) {
                setToken(response.data.token);
                return true;
            }
            return false;
        } catch (error) {
            console.error("Admin login failed:", error.response ? error.response.data : error.message);
            setToken(null);
            return false;
        }
    };

    const logout = () => {
        setToken(null);
    };

    const value = {
        token,
        isAuthenticated: !!token,
        isAppReady, 
        login,
        logout
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};